// Centralised route constants for the property-rent-ledger sub-module.
// A backend route rename is a one-file change.

const RENT_LEDGER = '/api/admin/rental-distributions/rent-ledger'

export const RENT_LEDGER_ENDPOINT_PATHS = {
  LIST: RENT_LEDGER,
  DETAIL: (propertyId: string) => `${RENT_LEDGER}/${propertyId}`,

  CREATE_BILL: `${RENT_LEDGER}/bills`,
  PAY_BILL: (billId: string) => `${RENT_LEDGER}/bills/${billId}/pay`,
  VOID_BILL: (billId: string) => `${RENT_LEDGER}/bills/${billId}/void`,
  BILL_PAYMENT_PERMISSION: (billId: string) => `${RENT_LEDGER}/bills/${billId}/payment-permission`,
} as const
